<template>
  <div class="relative mt-16 py-16 overflow-hidden lg:py-16">
    <div class="relative mx-auto px-4 max-w-prose sm:px-6 md:px-0">
      <slot></slot>
    </div>
  </div>
</template>
